import {useApi} from "../Api";
import {FormSearchRateModel, RateEntityRequest, RateEntityResponse,} from "../types/rate";
import {PagedResponse} from "../types/pagination";
import {buildQueryParams} from "../../utils";
import {SelectElementModelFE} from "../types/generic";

export const useRateRepository = () => {
    const {GET, POST, PUT, DELETE} = useApi();

    const PATH = "/pricing/rate";

    function getRate(rateId: number | string): Promise<RateEntityResponse> {
        return GET(`${PATH}?id=${rateId}`);
    }

    function getRateInUse(rateId: number): Promise<boolean> {
        return GET(`${PATH}/in-use?rateId=${rateId}`);
    }

    function getRateIsFather(rateId: number): Promise<boolean> {
        return GET(`${PATH}/is-father?rateId=${rateId}`);
    }

    function getRatesList(filters: FormSearchRateModel): Promise<RateEntityResponse[]> {
        const query = "?";

        const queryParams = buildQueryParams(filters);
        return GET(`${PATH}/filter${queryParams ? query + queryParams : ""}`);
    }

    function getRatesPaged(filters: FormSearchRateModel): Promise<PagedResponse<RateEntityResponse>> {
        const query = "?";

        const queryParams = buildQueryParams(filters);

        return GET(`${PATH}/page/filter${queryParams ? query + queryParams : ""}`);
    }

    function getLinkableRates(
        rateId: number | null,
        showOnlyActive: boolean,
        dealers: SelectElementModelFE | null,
        legalEntities: SelectElementModelFE | null
    ): Promise<RateEntityResponse[]> {
        const queryString = rateId ? `rateId=${rateId}&` : "";
        return GET(
            `${PATH}/get-linkable?${queryString}showOnlyActive=${showOnlyActive}&dealers=${dealers}&legalEntities=${legalEntities}`
        );
    }

    function getCloneableRates(
        tpUnit: string,
        showOnlyActive: boolean,
        dealers: SelectElementModelFE | null,
        legalEntities: SelectElementModelFE | null
    ): Promise<RateEntityResponse[]> {
        return GET(
            `${PATH}/get-cloneable?tpUnit=${tpUnit}&showOnlyActive=${showOnlyActive}&dealers=${dealers}&legalEntities=${legalEntities}`
        );
    }

    function putRate(rate: RateEntityResponse): Promise<RateEntityResponse> {
        return PUT(`${PATH}`, rate);
    }

    function postRate(rate: RateEntityRequest): Promise<RateEntityResponse> {
        return POST(`${PATH}`, rate);
    }

    function deleteRate(rateId: number): Promise<number> {
        return DELETE(`${PATH}?id=${rateId}`);
    }

    function terminateRate(rateId: number): Promise<RateEntityResponse> {
        return GET(`${PATH}/terminate?id=${rateId}`);
    }

    function getFatherRates(productCode: string): Promise<RateEntityResponse[]> {
        return GET(`${PATH}/get-father-rates?productCode=${productCode}`);
    }

    return {
        getRate,
        getRateInUse,
        getRatesPaged,
        getLinkableRates,
        getCloneableRates,
        putRate,
        postRate,
        deleteRate,
        terminateRate,
        getRateIsFather,
        getFatherRates,
        getRatesList
    };
};